import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoIosCloudUpload } from 'react-icons/io';
import { Upload, message } from 'antd';
import firebaseService from 'services/firebaseService.js';
import attachmentService from 'services/attachment.js';
import { DraggerWrapper } from './imageUploader.style';
import loadingGif from 'assets/images/pickapier/loading.svg';
import isNil from 'lodash/isNil';

const { Dragger } = Upload;

const DragAndDropUploader = ({
  onUploadChange,
  initialFileList,
  apiProps,
  accept,
  hidden = false,
  vessel_id
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const createAttachment = async data => {
    try {
      const res = await attachmentService.create(data);
      return res;
    } catch (err) {
      console.error(err);
    }
  };

  const uploadImage = async options => {
    setIsLoading(true);
    const { onSuccess, onError, file, onProgress } = options;
    firebaseService.uploadFile(
      file,
      ({ status, progress, file_path, file_type, name, ...args }) => {
        const data = {
          attachment_type: apiProps.attachment_type,
          shared_by_default: apiProps.shared_by_default,
          name,
          file_path,
          file_type
          // ...args,
          // ...apiProps,
        };

        if (status === 'PROCESSING') {
          onProgress({ percent: progress });
        } else if (status === 'DONE') {
          onProgress({ percent: 100 });
          if (!isNil(vessel_id)) {
            data.vessel_id = vessel_id;
          }

          attachmentService.create(data).then(res => {
            if (res && res.error_type) {
              message.error(`${name} upload failed.`);
            } else {
              onSuccess(res);
            }
            setIsLoading(false);
          });
        } else if (status === 'ERROR') {
          onError();
        }
      }
    );
  };

  const props = {
    accept,
    name: 'file',
    multiple: false,
    defaultFileList: initialFileList,
    customRequest: uploadImage,
    showUploadList: false,
    onSuccess(res) {
      onUploadChange(res);
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        // console.log(info.file, info.fileList);
        // onUploadChange(info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} upload failed.`);
      }
    }
  };

  return (
    <DraggerWrapper
      className={
        hidden ? 'hidden drag_and_drop_uploader' : 'drag_and_drop_uploader'
      }
    >
      <Dragger {...props} className='uploader'>
        {isLoading ? (
          <div className='ant-upload-drag-icon'>
            <img alt='Preview pic' src={loadingGif} />
          </div>
        ) : (
          <Fragment>
            <div className='ant-upload-drag-icon'>
              <IoIosCloudUpload />
            </div>
            <p className='ant-upload-text'>{t('DRAG_AND_DROP_DOCUMENTS')}</p>
          </Fragment>
        )}
      </Dragger>
    </DraggerWrapper>
  );
};

export default DragAndDropUploader;
